import { Link } from 'react-router-dom';
import AnimatedCounter from '../../components/feature/AnimatedCounter';
import { useSEO, generateBreadcrumbSchema, generateOrganizationSchema, generateWebPageSchema } from '../../utils/seo';

export default function Hakkimizda() {
  // SEO Configuration
  useSEO({
    title: 'Hakkımızda | ASSA İş Eğitimleri Akademisi Osmaniye - 8 Yıllık Deneyim',
    description: 'ASSA Akademi Osmaniye: 8 yıllık deneyim, 2500+ mezun, 150+ kurumsal firma. Sağlık Bakanlığı onaylı ilkyardım eğitimi, IRATA LEVEL 3 yüksekte çalışma ve iş güvenliği eğitim merkezi.',
    keywords: 'ASSA Akademi hakkında, Osmaniye ilkyardım eğitim merkezi, iş güvenliği eğitim kurumu Osmaniye, Sağlık Bakanlığı onaylı eğitim merkezi, IRATA LEVEL 3 eğitmenler',
    canonical: '/hakkimizda',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateBreadcrumbSchema([
          { name: 'Ana Sayfa', url: '/' },
          { name: 'Hakkımızda', url: '/hakkimizda' }
        ]),
        generateWebPageSchema('Hakkımızda', 'ASSA İş Eğitimleri Akademisi Osmaniye - 8 yıllık deneyim ile profesyonel eğitim hizmetleri', '/hakkimizda'),
        generateOrganizationSchema()
      ]
    }
  });

  const instructors = [
    {
      name: 'Dr. Mehmet Özkan',
      title: 'Baş Eğitmen - Acil Tıp Uzmanı',
      experience: '15 Yıl',
      image:
        'https://public.readdy.ai/ai/img_res/b13567a7872c3dcb26ad355054d4d284.jpg',
      description:
        'Acil Tıp uzmanı olarak 15 yıllık deneyime sahip. İstanbul Üniversitesi Tıp Fakültesi mezunu.',
    },
    {
      name: 'Hemşire Ayşe Demir',
      title: 'Eğitmen - Yoğun Bakım Hemşiresi',
      experience: '12 Yıl',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20female%20nurse%20in%20medical%20uniform%20smiling%20warmly%2C%20experienced%20healthcare%20worker%20with%20caring%20expression%2C%20medical%20facility%20background%2C%20confident%20nursing%20professional%20portrait&width=300&height=300&seq=instructor-2&orientation=squarish',
      description:
        'Yoğun bakım alanında 12 yıllık deneyim. Hacettepe Üniversitesi Hemşirelik Fakültesi mezunu.',
    },
    {
      name: 'Paramedik Ali Kaya',
      title: 'Eğitmen - 112 Acil Servis',
      experience: '10 Yıl',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20male%20paramedic%20in%20uniform%2C%20emergency%20medical%20services%20worker%20with%20confident%20expression%2C%20ambulance%20or%20medical%20facility%20background%2C%20experienced%20emergency%20responder%20portrait&width=300&height=300&seq=instructor-3&orientation=squarish',
      description:
        '112 Acil Serviste 10 yıl aktif görev. Anadolu Üniversitesi Sağlık Hizmetleri MYO mezunu.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-6">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/d976ad48ea6e824eb2b305836503c616.jfif" 
                alt="ASSA Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex space-x-8">
              <Link to="/" className="text-gray-700 hover:text-blue-600 cursor-pointer">
                Ana Sayfa
              </Link>
              <Link to="/egitimlerimiz" className="text-gray-700 hover:text-blue-600 cursor-pointer">
                Eğitimlerimiz
              </Link>
              <Link to="/hakkimizda" className="text-blue-600 font-semibold cursor-pointer">
                Hakkımızda
              </Link>
              <Link to="/sss" className="text-gray-700 hover:text-blue-600 cursor-pointer">
                SSS
              </Link>
              <Link to="/iletisim" className="text-gray-700 hover:text-blue-600 cursor-pointer">
                İletişim
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-[60vh] bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 flex items-center justify-center">
        <div className="container mx-auto px-6 text-white text-center">
          <div className="max-w-3xl mx-auto">
            <div className="mb-8 flex justify-center">
              <div className="bg-white rounded-2xl p-8 inline-block">
                <img 
                  src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/d976ad48ea6e824eb2b305836503c616.jfif" 
                  alt="ASSA Logo" 
                  className="h-32 w-auto"
                />
              </div>
            </div>
            <h1 className="text-5xl font-bold mb-6">Hakkımızda</h1>
            <p className="text-xl mb-8 leading-relaxed">
              2016 yılından bu yana Sağlık Bakanlığı onaylı ilkyardım eğitimleri veren,
              deneyimli ve uzman kadrosuyla güvenilir eğitim kurumu.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 mb-20">
            <div>
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-target-line text-2xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Misyonumuz</h2>
              <p className="text-gray-600 leading-relaxed text-lg mb-6">
                Toplumun her kesiminden bireylere, Sağlık Bakanlığı standartlarında ilkyardım
                eğitimi vererek, acil durumlarda hayat kurtarabilecek bilgi ve becerileri
                kazandırmak.
              </p>
              <p className="text-gray-600 leading-relaxed text-lg">
                Kaliteli eğitim anlayışımızla, her katılımcının güvenle müdahale edebileceği bir
                seviyeye ulaşmasını sağlamak temel hedefimizdir.
              </p>
            </div>

            <div>
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-2xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Vizyonumuz</h2>
              <p className="text-gray-600 leading-relaxed text-lg mb-6">
                Türkiye'de ilkyardım eğitimi alanında öncü akademi olmak ve toplumsal farkındalığı
                artırarak daha güvenli bir yaşam ortamı oluşturmaya katkıda bulunmak.
              </p>
              <p className="text-gray-600 leading-relaxed text-lg">
                İnovasyonu eğitim metodlarımızla birleştirerek, sürekli gelişen ve öğrenen bir kurum
                kimliği ile sektörde liderliğimizi sürdürmek.
              </p>
            </div>
          </div>

          {/* Values */}
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-12">Değerlerimiz</h2>
            <div className="grid md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">Güvenilirlik</h3>
                <p className="text-gray-600">Sağlık Bakanlığı onaylı eğitimlerle güven veriyoruz</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-star-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">Kalite</h3>
                <p className="text-gray-600">Yüksek standartlarda eğitim ve hizmet kalitesi</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">İnsani Değerler</h3>
                <p className="text-gray-600">Hayat kurtarma bilincini yaygınlaştırma</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-refresh-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">Sürekli Gelişim</h3>
                <p className="text-gray-600">Güncel bilgi ve teknolojilerle eğitim</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Sağlık Bakanlığı Onayları</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Eğitim faaliyetlerimiz Sağlık Bakanlığı tarafından onaylanmış ve denetlenmektedir
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl border border-blue-200 text-center">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-government-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Kuruluş İzni</h3>
              <p className="text-gray-700">
                Sağlık Bakanlığı tarafından verilen eğitim kurumu işletme izni
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-xl border border-green-200 text-center">
              <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Eğitim Yetkilendirme</h3>
              <p className="text-gray-700">
                İlkyardım eğitimi verme yetki belgesi ve akreditasyon
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-xl border border-purple-200 text-center">
              <div className="w-20 h-20 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Sertifika Yetkisi</h3>
              <p className="text-gray-700">
                Resmi geçerlilikte sertifika düzenleme yetkisi
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6">Rakamlarla Başarımız</h2>
            <p className="text-xl max-w-3xl mx-auto">
              8 yıllık deneyimimizle binlerce kişiye ilkyardım eğitimi verdik
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold mb-2">
                <AnimatedCounter end={2500} suffix="+" />
              </div>
              <div className="text-xl">Mezun Kursiyerimiz</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">
                <AnimatedCounter end={150} suffix="+" />
              </div>
              <div className="text-xl">Kurumsal Firma</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">
                <AnimatedCounter end={8} />
              </div>
              <div className="text-xl">Yıllık Deneyim</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">
                <AnimatedCounter end={98} suffix="%" />
              </div>
              <div className="text-xl">Başarı Oranı</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Bizimle İletişime Geçin</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Sağlık Bakanlığı onaylı eğitimlerimiz hakkında detaylı bilgi almak için
            bizimle iletişime geçebilirsiniz.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/iletisim"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              İletişime Geç
            </Link>
            <Link
              to="/egitimlerimiz"
              className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Eğitimleri İncele
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <p className="text-gray-300 leading-relaxed mb-6">
                Sağlık Bakanlığı onaylı ilkyardım eğitimleri ile hayat kurtarmayı öğrenin.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">Hızlı Linkler</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-white cursor-pointer">
                    Ana Sayfa
                  </Link>
                </li>
                <li>
                  <Link to="/egitimlerimiz" className="text-gray-300 hover:text-white cursor-pointer">
                    Eğitimlerimiz
                  </Link>
                </li>
                <li>
                  <Link to="/hakkimizda" className="text-gray-300 hover:text-white cursor-pointer">
                    Hakkımızda
                  </Link>
                </li>
                <li>
                  <Link to="/iletisim" className="text-gray-300 hover:text-white cursor-pointer">
                    İletişim
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">Eğitimler</h4>
              <ul className="space-y-3">
                <li>
                  <span className="text-gray-300">İSG Temel Eğitimi</span>
                </li>
                <li>
                  <span className="text-gray-300">Yüksekte Çalışma</span>
                </li>
                <li>
                  <span className="text-gray-300">Yangın Eğitimi</span>
                </li>
                <li>
                  <span className="text-gray-300">İlkyardım Eğitimi</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">İletişim</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-phone-line text-blue-400 mr-3"></i>
                  <span className="text-gray-300">0850 346 2772</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-blue-400 mr-3"></i>
                  <span className="text-gray-300">info@assaakademi.com.tr</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-blue-400 mr-3 mt-1"></i>
                  <span className="text-gray-300">Adnan Menderes, Emniyet Cd. 28/B, 80010 Osmaniye Merkez/Osmaniye</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 mt-12">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 mb-4 md:mb-0">
                © 2024 Assa İş Eğitimleri Akademisi. Tüm hakları saklıdır.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/+905324196401"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 animate-pulse cursor-pointer"
          title="WhatsApp ile iletişime geç"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
        </a>
      </div>
    </div>
  );
}
